import { HttpClientModule } from '@angular/common/http';
import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfigurationService } from './configuration.service';

const configFactory = (config: ConfigurationService): () => Observable<boolean> => () => config.load();

@NgModule({
  imports: [
    HttpClientModule
  ],
  providers: [provideAppInitializer(() => {
    const initializerFn = (configFactory)(inject(ConfigurationService));
    return initializerFn();
  })]
})
export class ConfigurationModule { }
